<template>
  <v-card class="okr-chart-card" elevation="0">
    <v-card-text class="pa-4">
      <div v-if="elementVisible && hasData">
        <vue-apex-charts type="bar" height="300" :options="chartOptions" :series="series"></vue-apex-charts>
      </div>
      <div v-else class="okr-chart-card__empty">
        <v-icon color="grey lighten-1">mdi-chart-bar</v-icon>
        <span>No hay información para el año y la semana seleccionados.</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'CompromisosXEstatus',
  props: {
    datos: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    series: [
      {
        name: 'Realizadas',
        data: []
      },
      {
        name: 'No realizadas',
        data: []
      }
    ],
    chartOptions: {
      grid: {
        show: true,
        borderColor: 'rgba(0, 0, 0, .3)',
        strokeDashArray: 3,
        padding: {
          left: 8,
          right: 28,
          bottom: 4
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '42%',
          endingShape: 'flat'
        }
      },
      colors: ['#10b981', '#d90429'],
      fill: {
        type: 'solid',
        opacity: 1
      },
      chart: {
        stacked: true,
        toolbar: {
          show: false
        },
        sparkline: {
          enabled: false
        }
      },
      title: {
        text: 'Actividades de la semana',
        align: 'center',
        margin: 5,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '18px',
          fontWeight: 'normal',
          fontFamily: 'Roboto, Helvetica, Arial',
          color: 'rgba(0, 0, 0, 0.8)'
        }
      },
      legend: {
        show: true,
        position: 'top',
        fontSize: '14px',
        fontFamily: 'Roboto, Helvetica, Arial',
        markers: {
          width: 14,
          height: 14,
          strokeWidth: 0,
          strokeColor: '#fff',
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
        labels: {
          colors: '#424242',
          useSeriesColors: false
        },
        itemMargin: {
          horizontal: 15,
          vertical: 5
        },
        onItemHover: {
          highlightDataSeries: true
        },
        onItemClick: {
          toggleDataSeries: true
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -4,
        style: {
          fontSize: '11px',
          fontWeight: '700'
        },
        formatter: function(value) {
          return Number(value) || 0;
        }
      },
      markers: {
        size: 0
      },
      xaxis: {
        categories: ['Total'],
        labels: {
          trim: true,
          style: {
            fontSize: '10px',
            fontWeight: 'bolder',
            cssClass: 'text-muted fill-color'
          }
        }
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            cssClass: 'text-muted fill-color'
          }
        }
      },
      stroke: {
        curve: 'straight',
        width: 0
      },
      tooltip: {
        theme: 'dark',
        y: {
          formatter: function(value) {
            return `${Number(value) || 0} actividades`;
          }
        }
      }
    },
    elementVisible: false,
    hasData: false
  }),
  watch: {
    datos(val) {
      let realizadas = [];
      let norealizadas = [];
      if (val.totaltareassemana != undefined) {
        if (val.totaltareassemana.length > 0) {
          realizadas.push(Number(val.totaltareassemana[0].totaltareasrealizadas) || 0);
          norealizadas.push(Number(val.totaltareassemana[0].totaltareasnorealizadas) || 0);
          const axisMax = this.getAxisMax([realizadas[0] + norealizadas[0]]);
          this.series = [
            {
              name: 'Realizadas',
              data: realizadas
            },
            {
              name: 'No realizadas',
              data: norealizadas
            }
          ];
          this.chartOptions = {
            ...this.chartOptions,
            xaxis: {
              ...this.chartOptions.xaxis,
              max: axisMax
            }
          };
          this.hasData = realizadas[0] + norealizadas[0] > 0;
        } else {
          this.series = [];
          this.hasData = false;
        }
        this.elementVisible = true;
      }
    }
  },
  mounted() {
    this.applyThemeColors();
  },
  methods: {
    applyThemeColors() {
      const primary = (this.$vuetify && this.$vuetify.theme.currentTheme.primary) || '#d90429';
      this.chartOptions = {
        ...this.chartOptions,
        colors: ['#10b981', primary]
      };
    },
    getAxisMax(values) {
      const maxValue = Math.max(...values.map((value) => Number(value) || 0), 0);
      return maxValue > 0 ? Math.ceil(maxValue * 1.18) : undefined;
    }
  },
  components: {
    VueApexCharts
  }
};
</script>

<style lang="scss" scoped>
.okr-chart-card {
  border: 1px solid #e5e8ef;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  margin-bottom: 0;
  overflow: visible;
}

::v-deep .apexcharts-canvas,
::v-deep .apexcharts-svg {
  overflow: visible;
}

.okr-chart-card__empty {
  align-items: center;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 8px;
  justify-content: center;
  min-height: 300px;
  text-align: center;
}
</style>
